import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import auth from '../../firebase.init.js';
import { Navigate, useLocation } from 'react-router-dom';

const RequireAuth = ({ children }) => {

     const [user] = useAuthState(auth);
     const location = useLocation()

     if (!user) {
          return <Navigate to="/login" state={{ from: location }} />;
     }

     return children;
};

export default RequireAuth;